import { gql } from '@apollo/client';

export const ADD_TRAINING_PHASE = gql`
    mutation addTrainingPhase($phaseInput: TrainingPhaseInput!){
        addTrainingPhase(phaseInput: $phaseInput) {
            _id
        }
    }
`;
